<div>
  <br>
  <form [formGroup]="formAdministratorCrud">
    <div class="card text-center">
      <div class="card-header titleModalCrud">
        <h5>Cadastro de Administradores de Aeroportos</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-2 label">
            <label for="administratorName">Nome da administradora: </label>
          </div>
          <div class="col-10">
            <mat-form-field class="example-full-width inputLayout">
              <input matInput id="administratorName" name="administratorName" formControlName="administratorName"
                     [(ngModel)]="administrator.name" placeholder="Nome" aria-label="Nome">
            </mat-form-field>

            <button mat-raised-button type="button" class="btmAddAirport" matTooltip="Adicionar um novo Aeroporto"
                    (click)="createdNewAirport()">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>

        <div class="row">
          <div class="formRegistreAirport">
            <div [formGroup]="formAdministratorAirportCrud">
              <br>
              <div class="row">
                <div class="col-2 label">
                  <label for="airportRegisterHostFTP">FTP Host:</label>
                </div>
                <div class="col-4">
                  <mat-form-field style="width:100%">
                    <input matInput id="airportRegisterHostFTP" name="airportRegisterHostFTP"
                           formControlName="airportRegisterHostFTP" aria-label="FTP Host" autocomplete="off"
                           [(ngModel)]="airportRegister.host" class="form-control" placeholder="Host FTP" />
                  </mat-form-field>
                </div>

                <div class="col-2 label">
                  <label for="airportRegisterPathFTP">FTP Path RPE:</label>
                </div>
                <div class="col-4">
                  <mat-form-field style="width: 100%;">
                    <input matInput id="airportRegisterPathFTP" name="airportRegisterPathFTP"
                           formControlName="airportRegisterPathFTP" aria-label="FTP Path" autocomplete="off"
                           [(ngModel)]="airportRegister.pathRPE" class="form-control" placeholder="Path RPE FTP" />
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-2 label">
                  <label for="airportRegisterPathSeloFTP">FTP Path Selo:</label>
                </div>
                <div class="col-4">
                  <mat-form-field style="width:100%">
                    <input matInput id="airportRegisterPathSeloFTP" name="airportRegisterPathSeloFTP"
                           formControlName="airportRegisterPathSeloFTP" aria-label="FTP Path" autocomplete="off"
                           [(ngModel)]="airportRegister.pathStamp" class="form-control" placeholder="Path Selo FTP" />
                  </mat-form-field>
                </div>

                <div class="col-2 label">
                  <label for="airportRegisterUserFTP">FTP Usuário:</label>
                </div>
                <div class="col-4">
                  <mat-form-field style="width: 100%;">
                    <input matInput id="airportRegisterUserFTP" name="airportRegisterUserFTP"
                           formControlName="airportRegisterUserFTP" aria-label="FTP User" autocomplete="off"
                           [(ngModel)]="airportRegister.user" class="form-control" placeholder="User FTP" />
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-2 label">
                  <label for="airportRegisterSecretFTP">FTP Senha:</label>
                </div>
                <div class="col-10">
                  <mat-form-field style="width:100%">
                    <input matInput [type]="hide ? 'password' : 'text'" id="airportRegisterSecretFTP"
                           name="airportRegisterSecretFTP" formControlName="airportRegisterSecretFTP"
                           aria-label="FTP Secret" autocomplete="off" [(ngModel)]="airportRegister.secret"
                           class="form-control" placeholder="Secret FTP" />
                    <button mat-icon-button matSuffix type="button" (click)="hide = !hide"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                      <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
              </div>

              <br>
              <div class="row">
                <div class="tableAirportRegistred" style="width: 100%;">
                  <table mat-table [dataSource]="dataSourceAirportsAllow" class="mat-elevation-z8" style="width: 100%;">
                    <ng-container matColumnDef="identification">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let airport"></td>
                    </ng-container>

                    <ng-container matColumnDef="iataCode">
                      <th mat-header-cell *matHeaderCellDef>Cód. IATA</th>
                      <td mat-cell *matCellDef="let airport">{{ airport.airportCode?.codeIATA }}</td>
                    </ng-container>

                    <ng-container matColumnDef="decription">
                      <th mat-header-cell *matHeaderCellDef>Nome</th>
                      <td mat-cell *matCellDef="let airport">{{ airport.airportCode?.descriptionName }}</td>
                    </ng-container>

                    <ng-container matColumnDef="editOrDelete">
                      <th mat-header-cell *matHeaderCellDef>Excluir</th>
                      <td mat-cell *matCellDef="let airport">
                        <button mat-raised-button type="button" class="btn btn-danger btnDeleteAirport"
                                (click)="deleteAirport(airport)">
                          <mat-icon style="margin-left: 1%;font-size: x-large;">delete</mat-icon>
                        </button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <br>
      </div>
    </div>
  </form>
</div>

<ng-template #addAirportDialog>
  <h2 mat-dialog-title>Adicionar Aeroporto</h2>

  <mat-dialog-content class="airportAddDialogContent">
    <mat-form-field class="airportAddCombo">
      <mat-label>Aeroporto</mat-label>
      <mat-select [(value)]="airportSelectedInModal" (selectionChange)="selectAirportInModal($event.value)">
        <mat-option *ngFor="let airport of airportComboOptions" [value]="airport">
          {{ formatAirportOption(airport) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="airportAddEmpty" *ngIf="airportComboOptions.length === 0">
      Nenhum aeroporto disponível para vincular.
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="airportAddActions">
    <button mat-raised-button type="button" class="btnClean" (click)="cancelAddAirport()">
      <mat-icon>clear</mat-icon>
      Cancelar
    </button>

    <button mat-raised-button type="button" class="mainButtom" (click)="requestSaveAirportInModal()"
            [disabled]="!airportSelectedInModal">
      <mat-icon>save</mat-icon>
      Salvar
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #confirmSaveAirportDialog>
  <h2 mat-dialog-title>Atenção!</h2>

  <mat-dialog-content>
    <label>Você deseja realmente salvar este aeroporto?</label>
  </mat-dialog-content>

  <mat-dialog-actions class="airportAddActions">
    <button mat-raised-button type="button" class="btnClean" [mat-dialog-close]="false">
      <mat-icon>clear</mat-icon>
      Cancelar
    </button>

    <button mat-raised-button type="button" class="mainButtom" [mat-dialog-close]="true">
      <mat-icon>save</mat-icon>
      Salvar
    </button>
  </mat-dialog-actions>
</ng-template>
